import { render, staticRenderFns } from "./photoApprove.vue?vue&type=template&id=dcc0020c&scoped=true"
import script from "./photoApprove.vue?vue&type=script&lang=js"
export * from "./photoApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0020c",
  null
  
)

export default component.exports